export class MinifyListValueConverter {
    toView(value, maxLength = 20) {
        if (Array.isArray(value)) {
            const fullString = value.join(', ');
            return fullString.substring(0, maxLength);
        } else {
            return value;
        }
    }
}